export class VendorAccountNumberVerifyResultDto {
    isAccountNumberMatches: boolean;
}
